import { OfferQuery } from './../../generated/graphql_offer';

export const demoOfferData: Array<{
  data: { offer: OfferQuery['offer'] };
}> = [
  {
    data: {
      offer: {
        id: 'DEMOOFFER1',
        assignmentStatus: 'ASSIGNED',
        rewardQuota: 3,
        assignments: [
          {
            id: 'DEMOA1',
            status: 'ASSIGNED',
            assignedStatus: 'SUBMITTED',
            candidatedStatus: null,
            user: {
              id: '18696',
              name: 'Kaizen Ad CS',
              profileImageUrl: '',
            },
            reputation: null,
            reputationToOffer: null,
          },
          {
            id: 'DEMOA2',
            status: 'ASSIGNED',
            assignedStatus: 'SUBMITTED',
            candidatedStatus: null,
            user: {
              id: '18696',
              name: 'Kaizen Ad CS',
              profileImageUrl: '',
            },
            reputation: null,
            reputationToOffer: null,
          },
          {
            id: 'DEMOA3',
            status: 'ASSIGNED',
            assignedStatus: 'SUBMITTED',
            candidatedStatus: null,
            user: {
              id: '18696',
              name: 'Kaizen Ad CS',
              profileImageUrl: '',
            },
            reputation: null,
            reputationToOffer: null,
          },
        ],
      },
    },
  },
  {
    data: {
      offer: {
        id: 'DEMOOFFER2',
        assignmentStatus: 'ASSIGNED',
        rewardQuota: 1,
        assignments: [
          {
            id: 'DEMOA4',
            status: 'ASSIGNED',
            assignedStatus: 'SUBMITTED',
            candidatedStatus: null,
            user: {
              id: '18696',
              name: 'Kaizen Ad CS',
              profileImageUrl: '',
            },
            reputation: null,
            reputationToOffer: null,
          },
        ],
      },
    },
  },
];

export const getDemoOffer = (id: string) => demoOfferData.map((d) => d.data.offer).find((o) => o.id === id);
